module.exports = __webpack_public_path__ + "static/media/GunaldiHeroImage.7cad33ca.svg";